export const watch = {
  async doc() {
    await this.retrieveDocument()
  },
  async documentID() {
    await this.retrieveDocument()
  }
}
